import React from "react";
import { Link } from "react-router-dom";

function CTAWrapper() {
  
  return (
    <div>
      <section
        className="cta-wrapper jarallax"
        data-jarallax
        data-speed="0.2"
        style={{ backgroundImage: "url('assets/img/bg-img/23.jpg')" }}
      >
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-9 col-lg-8">
              <div className="section-heading text-center">
                <div
                  className="sub-title text-white justify-content-center wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1000ms"
                >
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Book Appointment
                </div>
                <h2
                  className="wow fadeInUp"
                  data-wow-delay="600ms"
                  data-wow-duration="1000ms"
                >
                  Free Case Evaluation by Injury Attorney
                </h2>
                <Link
                  className="btn btn-primary wow fadeInUp"
                  to="/contactone"
                  data-wow-duration="1000ms"
                  data-wow-delay="800ms"
                >
                  <span>
                    Book Appointment <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Book Appointment <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default CTAWrapper;
